<template>
  <b-row>
    <b-col v-for="widget of stats" :key="widget.title" cols="6" xl="3">
      <StatIcon
        :icon="widget.icon"
        :title="widget.title"
        :number="widget.number"
        :subtext="widget.subtext"
        :color="widget.color"
      />
    </b-col>
  </b-row>
</template>

<script lang="ts">
import type { StatisticItem } from '@/typings/Assignments/StatisticItem'
import { defineComponent, type PropType } from 'vue'
import StatIcon from '@/views/components/widgets/widget-stat-icon.vue'

export default defineComponent({
  components: { StatIcon },
  props: {
    stats: {
      type: Array as PropType<StatisticItem[]>,
      required: true,
    },
  },
})
</script>
